import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import { appendCapKeysToFormData } from "../../../../../core/service/utils/fileUpload";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { EmvGlobalConfigurationEntity } from "../../types/EmvGlobalConfigurationEntity";
import { EmvGlobalConfigurationDtoToEntity } from "../mappers/EmvGlobalConfigurationDtoToEntity";
import { EmvGlobalConfigurationEntityToDto } from "../mappers/EmvGlobalConfigurationEntityToDto";

const EmvGlobalConfigurationApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        EmvGlobalConfigurationLoad: builder.query<EmvGlobalConfigurationEntity, void>({
            providesTags: [ResourceName.EMV_GLOBAL_CONFIGURATIONS],
            query: () => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_GLOBAL_CONFIGURATIONS}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return EmvGlobalConfigurationDtoToEntity(response);
            },
        }),
        EmvGlobalConfigurationUpdate: builder.mutation<EmvGlobalConfigurationEntity, FormMutation<EmvGlobalConfigurationEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();
                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.EMV_GLOBAL_CONFIGURATIONS}/${mutation.data.id}`;
                const method = "PUT";

                const body = EmvGlobalConfigurationEntityToDto(mutation.data);

                const formData = new FormData();
                appendCapKeysToFormData(formData, mutation.data);

                formData.append("dto", new Blob([JSON.stringify(body)], { type: "application/json" }));

                return {
                    url,
                    method,
                    body: formData,
                };
            },
            invalidatesTags: [ResourceName.EMV_GLOBAL_CONFIGURATIONS],
        }),
    }),
});

export const { useEmvGlobalConfigurationLoadQuery, useEmvGlobalConfigurationUpdateMutation } = EmvGlobalConfigurationApi;
